export function comentarioError(state, payload){
    state.error = true
    state.errorMessage = payload
    state.comentarios = ''
    state.comentario = ''
    
}
export function setComentarios(state, payload){
    state.comentarios = payload.data.data
    state.error= false
    state.errorMessage = ''
}
/**
 * metodo llamado desde la vista
 * @param {*} state 
 * @param {*} payload 
 */
export function setComentario(state,payload){
    state.comentario = payload
    state.error = false
    state.errorMessage = ''
}
